import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'amfori_credentials_verified_at'

export const dataPointDefinition = {
  retracedId: 'amfori_credentials_verified_at',
  name: 'amfori Credentials Verified At',
  description:
    'ISO-8601 timestamp recording the last time the stored amfori OAuth2 credentials were successfully exchanged for an access token.',
  meta: {integration: 'AMFORI'},
  fieldTypeId: 'DATE',
  type: 'GLOBAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 37840,
  sectionId: '1.2',
  impactArea: 'Other IDs',
  impactAreaId: 'OTHER_IDS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
